import { useCustomTranslation } from '@e3dc-react/shell/Hooks/useCustomTranslation'
import { useState } from 'react'
import { PlaceholderOptions } from 'src/Types/globalTypes'
import { NotificationsFilter } from '../types'

enum filterReadAt {
  Read = 'ISNOTNULL',
  Unread = 'ISNULL',
}

export const useNotificationsFilterOptions = (): NotificationsFilter => {
  const { t } = useCustomTranslation()
  const readOptions: PlaceholderOptions<string | undefined> = {
    placeholder: t('systemlog.sortFilter'),
    options: [
      { label: t('notifications.all'), value: undefined },
      { label: t('notifications.unread'), value: filterReadAt.Unread },
      { label: t('notifications.read'), value: filterReadAt.Read },
    ],
    activeValue: undefined,
    size: 'small',
    fieldName: 'readAt',
  }

  const [readFilter, setReadFilter] = useState<PlaceholderOptions<string | undefined>>(readOptions)

  const setReadFilterValue = (activeValue: string | undefined): void => {
    setReadFilter(state => ({ ...state, activeValue }))
  }

  return { readFilter, setReadFilterValue }
}
